module.exports = __webpack_public_path__ + "static/media/IMG_8726.5e5d5f9a.JPG";